import { useContext } from 'react'
import { HomeContext } from 'pages/home/state/home-context'
import { useApiGetTeamLastFourWeeksPerformance } from 'core/api/home/useApiGetTeamLastFourWeeksPerformance'
import { getPathFromRouteId } from 'core/utils/route-utils'
import { RouteId } from 'core/routing/router/route-ids'
import WidgetLoading from 'components/common/cards/widget-loading'
import WidgetErrorCard from 'components/common/cards/widget-error-card'
import LastFourWeeksTeamPerformanceHeader from './last-four-weeks-team-performance-header'
import TopModelsContent from './top-models-content'
import WeeklyGmvSection from 'pages/home/components/weekly-gmv-chart/weekly-gmv-section'
import { useNavigate } from 'react-router'
import { HOMEPAGE_CARD_REDIRECTS, HOMEPAGE_EVENTS } from 'core/constants/homepage-analytics'
import { useHomepageAnalytics } from '../../analytics/use-homepage-analytics'
import { TEMPLATE_NAME } from '../../../../core/utils/templates'

const getDebriefDepartmentManagerTemplate = (templates: { id: number; label: string }[]) => {
  return templates?.find(template => template.label.startsWith(TEMPLATE_NAME.DEBRIEF_DEPARTMENT_MANAGER)) ?? ''
}
const LastFourWeeksTeamPerformance = () => {
  const navigate = useNavigate()
  const trackHomepageEvent = useHomepageAnalytics()
  const { aggregation, teamId, channel, storeId, store, templates } = useContext(HomeContext)
  const currency = store?.currency ?? ''
  const shouldDisplay = !!storeId && !!teamId && aggregation === 'TEAM'

  const { data, isLoading } = useApiGetTeamLastFourWeeksPerformance({ storeId, teamId, channel }, shouldDisplay)
  const topGmvModel = data?.topGmvModel
  const topQuantityModel = data?.topQuantityModel
  const weeklyGmv = data?.weeklyGmv

  const openWeeklyPilotingByTeam = () => {
    trackHomepageEvent(HOMEPAGE_EVENTS.CARD_REDIRECT_CLICK, { card: HOMEPAGE_CARD_REDIRECTS.LAST_FOUR_WEEKS_TEAM })
    const teamSearch = teamId ? `&team=${teamId}` : ''
    const debriefDepartmentManagerTemplate = getDebriefDepartmentManagerTemplate(templates)
    const templateSearch = debriefDepartmentManagerTemplate ? `&template=${debriefDepartmentManagerTemplate.id}` : ''
    void navigate(`${getPathFromRouteId(RouteId.WeeklyTeams)}?store_id=${storeId}${teamSearch}${templateSearch}`)
  }

  return (
    <section data-testid="last-four-weeks-team-performance" className="mg-last-four-weeks-team-performance">
      {isLoading && <WidgetLoading />}
      {!isLoading && (
        <>
          <LastFourWeeksTeamPerformanceHeader onOpenDetails={openWeeklyPilotingByTeam} />
          {topGmvModel && topQuantityModel ? (
            <TopModelsContent topGmvModel={topGmvModel} topQuantityModel={topQuantityModel} currency={currency} />
          ) : (
            <WidgetErrorCard
              titleKey="homepage.last-four-weeks-team-performance.models-label"
              testId="last-four-weeks-top-models-error"
            />
          )}
          <WeeklyGmvSection weeklyGmv={weeklyGmv} currency={currency} />
        </>
      )}
    </section>
  )
}

export default LastFourWeeksTeamPerformance
